module.exports = __webpack_public_path__ + "img/hand-drag.a9fe7864.svg";